module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9cnJF"))).then(() => parcelRequire('d0iPb'));